import { render } from "./KeyTab.vue?vue&type=template&id=2b22041a"
import script from "./KeyTab.vue?vue&type=script&lang=ts"
export * from "./KeyTab.vue?vue&type=script&lang=ts"
script.render = render

export default script